import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-revico-community-talk-talkroom-count", "data-revico-community-talk-talkroom-count-with-reply"]
const _hoisted_2 = { class: "revico-community-talk-talkroom-count--all" }
const _hoisted_3 = { class: "revico-community-talk-talkroom-count--with-reply" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: "revico-community-talk-talkroom-count",
    "data-revico-community-talk-talkroom-count": $props.talkRoomCount,
    "data-revico-community-talk-talkroom-count-with-reply": $props.talkRoomCountWithReply
  }, [
    _createElementVNode("p", _hoisted_2, "全" + _toDisplayString($props.talkRoomCount) + _toDisplayString($props.wordSettings.postCountUnit), 1 /* TEXT */),
    _createElementVNode("p", _hoisted_3, _toDisplayString($props.wordSettings.talkRoomWithReplyText) + ":" + _toDisplayString($props.talkRoomCountWithReply) + _toDisplayString($props.wordSettings.postCountUnit), 1 /* TEXT */)
  ], 8 /* PROPS */, _hoisted_1))
}